module.exports = __webpack_public_path__ + "static/media/ideiaPurple.7a4f02f9.svg";